import React from 'react';
import ReactSelect from 'react-select';

export const Select = ({ options, onChange, ...props }) => (
  <ReactSelect options={options} onChange={onChange} {...props} />
);

export default Select;
